module.exports = __webpack_public_path__ + "img/button-text-numbered-list.be2830c.svg";